import { useState } from "react";
import { Dialog, DialogContent } from "./ui/dialog";
import { Button } from "./ui/button";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const SLMConsentModal = ({ user, onConsent, onDecline }) => {
  const [submitting, setSubmitting] = useState(false);

  const handleConsent = async () => {
    setSubmitting(true);
    try {
      await axios.put(`${API}/users/me/slm-consent`, 
        { consent: true },
        { withCredentials: true }
      );
      onConsent();
    } catch (error) {
      console.error("Error saving consent:", error);
    } finally {
      setSubmitting(false);
    }
  };

  const handleDecline = async () => {
    setSubmitting(true);
    try {
      await axios.put(`${API}/users/me/slm-consent`, 
        { consent: false },
        { withCredentials: true }
      );
      onDecline();
    } catch (error) {
      console.error("Error saving consent:", error);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Dialog open={true} modal={true}>
      <DialogContent 
        className="bg-[#1C2130] border-[rgba(255,255,255,0.07)] max-w-lg p-8"
        onPointerDownOutside={(e) => e.preventDefault()}
        onEscapeKeyDown={(e) => e.preventDefault()}
      >
        {/* Heading */}
        <h2 
          className="text-2xl text-white mb-6"
          style={{ fontFamily: 'Playfair Display, serif' }}
        >
          One thing before you begin
        </h2>

        {/* Body */}
        <p className="text-slate-400 text-[14px] font-light leading-relaxed mb-8">
          Your ClarityOS sessions generate valuable data about leadership state 
          patterns. With your permission, anonymised and aggregated session data 
          may be used to train the Strata Leadership Model - an AI model built 
          specifically to understand leadership state transitions. Your data is 
          never shared individually. You can withdraw consent at any time in 
          Settings.
        </p>

        {/* Buttons */}
        <div className="flex flex-col gap-3">
          <Button
            onClick={handleConsent}
            disabled={submitting}
            className="w-full bg-[#C8860A] text-[#0D0F14] hover:bg-[#D4963A] uppercase text-[11px] tracking-wider py-3"
            style={{ fontFamily: 'DM Mono, monospace', borderRadius: '2px' }}
            data-testid="slm-consent-accept"
          >
            {submitting ? "Processing..." : "I consent - begin my protocol"}
          </Button>
          
          <Button
            onClick={handleDecline}
            disabled={submitting}
            variant="ghost"
            className="w-full border border-[rgba(255,255,255,0.2)] text-slate-400 hover:text-white hover:border-[rgba(255,255,255,0.5)] uppercase text-[11px] tracking-wider py-3"
            style={{ fontFamily: 'DM Mono, monospace', borderRadius: '2px' }}
            data-testid="slm-consent-decline"
          >
            Not now - I'll decide in Settings
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default SLMConsentModal;
